export class ContentToggleButton {

    private $button: JQuery;
    private $targetContent: JQuery;

    constructor($button: JQuery) {
        this.$targetContent = $($button.attr('href'));
        this.$button = $button;
        this.$button.on('click', (e) => this.onButtonClick(e));
    }

    private onButtonClick(e: JQuery.ClickEvent) {
        if (this.$targetContent.is(':visible')) {
            this.$targetContent.slideUp(
                {
                    'duration': 150,
                    'progress': function () {
                        window.dispatchEvent(new Event('resize'));
                    }
                }
            );
        } else {
            this.$targetContent.slideDown(
                {
                    'duration': 150,
                    'progress': function () {
                        window.dispatchEvent(new Event('resize'));
                    }
                }
            );
        }

        return false;
    }
}